export default __webpack_public_path__ + "static/Quickinstallation_Tile_8815_Step_03-65e7ceeab73502e2384e04256d0b998a.webp";